const ONES = [
  '',
  'One',
  'Two',
  'Three',
  'Four',
  'Five',
  'Six',
  'Seven',
  'Eight',
  'Nine',
  'Ten',
  'Eleven',
  'Twelve',
  'Thirteen',
  'Fourteen',
  'Fifteen',
  'Sixteen',
  'Seventeen',
  'Eighteen',
  'Nineteen',
];

const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

const convertBelowHundred = (n) => {
  if (n < 20) return ONES[n];
  const word = TENS[Math.floor(n / 10)];
  const remainder = n % 10;
  return remainder ? `${word}-${ONES[remainder]}` : word;
};

const convertBelowThousand = (n) => {
  if (n < 100) return convertBelowHundred(n);
  const hundreds = Math.floor(n / 100);
  const remainder = n % 100;
  const hundredPart = `${ONES[hundreds]} Hundred`;
  return remainder ? `${hundredPart} ${convertBelowHundred(remainder)}` : hundredPart;
};

const convertIntegerToWords = (n) => {
  if (!Number.isFinite(n) || n < 0) return '';
  if (n === 0) return 'Zero';

  const parts = [];
  let remaining = Math.floor(n);
  const crore = Math.floor(remaining / 10000000);
  remaining %= 10000000;
  const lakh = Math.floor(remaining / 100000);
  remaining %= 100000;
  const thousand = Math.floor(remaining / 1000);
  remaining %= 1000;

  if (crore) parts.push(`${convertBelowHundred(crore)} Crore`);
  if (lakh) parts.push(`${convertBelowHundred(lakh)} Lakh`);
  if (thousand) parts.push(`${convertBelowHundred(thousand)} Thousand`);
  if (remaining) parts.push(convertBelowThousand(remaining));

  return parts.join(', ');
};

/** Convert a numeric amount to Indian Rupees in words for invoice/quotation display. */
export const amountToWordsINR = (amount) => {
  const num = Math.round((Number(amount) || 0) * 100) / 100;
  if (num === 0) return 'INR Zero Rupees Only. E. & O.E';

  const rupees = Math.floor(num);
  const paise = Math.round((num - rupees) * 100);

  let result = `INR ${convertIntegerToWords(rupees)} Rupees`;
  if (paise > 0) {
    result += ` and ${convertIntegerToWords(paise)} Paise`;
  }
  return `${result} Only. E. & O.E`;
};
